import * as React from "react";

import "./relink-modal.scss";

import {cs} from "@Common/react/chain-services";

import {ModalService3} from "../../../../modal-service-3/modal-service-3";

export const RelinkModal = ({next: rootNext}) => cs(
    ["modal", (_, next) => ModalService3({
        // xToClose: false,
        title: "LinkedIn relink required",
        xdQaName: "Relink Modal",
        next,
        rootNext,
    })],
    ({modal}) => (
        <div className="relink-modal-5je">
            {/*<div className="title">*/}
            {/*    LinkedIn relink required*/}
            {/*</div>*/}
            <div className="message">
                Due to recent changes in LinkedIn API, we need to relink your Linkedin account to continue sharing your content. This is a one-time action, Thank you for understanding!
            </div>
            <div className="footer">
                <button
                    className="danger"
                    onClick={() => modal.close({removeLinkedIn: true})}
                    xd-qa-type="button"
                >
                    Remove LinkedIn
                </button>
                <button
                    className="next"
                    onClick={() => modal.close({relink: true})}
                    xd-qa-type="button"
                >
                    Relink LinkedIn
                </button>
            </div>
        </div>
    )
);
